/**
 * Toast action handler.
 * Delegates to the configured toast driver (toastr, smart-toast, or custom).
 */
let toast = (actionData) => {
    // Try toastr first (most common)
    if (typeof window.toastr !== 'undefined') {
        window.toastr[actionData.type](actionData.message, actionData.title, actionData.options);
        return;
    }

    // Fallback: native browser notification-style alert
    console.warn('[Smart] No toast library loaded. Falling back to console.');
    console[actionData.type === 'error' ? 'error' : 'log'](`[${actionData.type}] ${actionData.title}: ${actionData.message}`);
};

export default toast;
